import ProductTemplateColumnsDropdown from "components/basic/dropdowns/product-template-columns-dropdown/ProductTemplateColumnsDropdown";
import { IProductTemplateTableEditor } from "components/ComponentTypeTypes";
import { InputNumberValueChangeEvent } from "primereact/inputnumber";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import React from "react";
import { T } from "services/lang/LanguageService";

interface ProductTemplateTableConfigProps {
  currentConfig: IProductTemplateTableEditor;
  handleConfigChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | InputNumberValueChangeEvent
      | InputSwitchChangeEvent
      | MultiSelectChangeEvent
  ) => void;
}

const ProductTemplateTableConfig = ({
  currentConfig,
  handleConfigChange,
}: ProductTemplateTableConfigProps) => {
  return (
    <>
      <div className="w-full flex flex-column md:flex-row justify-content-between">
        <div className="w-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="showTitle">{T("chart-config.show-title")}</label>
          <InputSwitch
            id="showTitle"
            checked={Boolean(currentConfig.showTitle)}
            onChange={handleConfigChange}
          />
        </div>
        <div className="w-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="showFilter">{T("component.show-filter")}</label>
          <InputSwitch
            id="showFilter"
            checked={Boolean(currentConfig.showFilter)}
            onChange={handleConfigChange}
          />
        </div>
        <div className="w-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="showTotals">{T("component.show-totals")}</label>
          <InputSwitch
            id="showTotals"
            checked={Boolean(currentConfig.showTotals)}
            onChange={handleConfigChange}
          />
        </div>
        <div className="w-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="hideDates">{T("component.hide-dates")}</label>
          <InputSwitch
            id="hideDates"
            checked={Boolean(currentConfig.hideDates)}
            onChange={handleConfigChange}
          />
        </div>
        <div className="w-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="hidePagination">{T("action.hide-pagination")}</label>
          <InputSwitch
            id="hidePagination"
            checked={Boolean(currentConfig.hidePagination)}
            onChange={handleConfigChange}
          />
        </div>
        <div className="w-2 gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="isColumnsSortable">{T("label.sortable-columns")}</label>
          <InputSwitch
            id="isColumnsSortable"
            checked={Boolean(currentConfig.isColumnsSortable)}
            onChange={handleConfigChange}
          />
        </div>
      </div>
      {currentConfig.safeName && (
        <div className="flex w-full gap-3 mt-3">
          <div className="w-4 md:w-4 gap-2 flex flex-column justify-content-center align-items-center">
            <label htmlFor="hiddenColumns">{T("component.hidden-columns")}</label>
            <ProductTemplateColumnsDropdown
              id="hiddenColumns"
              value={Array.isArray(currentConfig.hiddenColumns) ? currentConfig.hiddenColumns : []}
              className="w-full"
              onChange={handleConfigChange}
              selectedTemplate={{
                refName: currentConfig.safeName,
                value: currentConfig.id!,
              }}
            />
          </div>
          <div className="w-4 md:w-4 gap-2 flex flex-column justify-content-center align-items-center">
            <label htmlFor="onlyShownColumns">{T("component.only-show-columns")}</label>
            <ProductTemplateColumnsDropdown
              id="onlyShownColumns"
              value={Array.isArray(currentConfig.onlyShownColumns) ? currentConfig.onlyShownColumns : []}
              className="w-full"
              onChange={handleConfigChange}
              selectedTemplate={{
                refName: currentConfig.safeName,
                value: currentConfig.id!,
              }}
              disabled={currentConfig.hiddenColumns && currentConfig.hiddenColumns?.length > 0}
            />
          </div>
          <div className="w-2 gap-2 flex flex-column justify-content-center align-items-center">
            <label htmlFor="allowAddEntry">{T("component.allow-add-entry")}</label>
            <InputSwitch
              id="allowAddEntry"
              checked={Boolean(currentConfig.allowAddEntry)}
              onChange={handleConfigChange}
            />
          </div>
          <div className="w-2 gap-2 flex flex-column justify-content-center align-items-center">
            <label htmlFor="allowRowEdit">{T("component.allow-row-edit")}</label>
            <InputSwitch
              id="allowRowEdit"
              checked={Boolean(currentConfig.allowRowEdit)}
              onChange={handleConfigChange}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ProductTemplateTableConfig;
